import type { EvidenceUploadMode, ModelResults } from 'api';

import type { AnalysisStatus } from '../../types';
import { getAnalysisStatusUsingBaleModel } from './getAnalysisStatusUsingBaleModel';

export const getAnalysisStatus = (mode: EvidenceUploadMode, model_results: ModelResults): AnalysisStatus => {
  return getAnalysisStatusUsingBaleModel(model_results, mode);
};
